import React from 'react';
import PropTypes from 'prop-types';
import ThemeContext from '../theme-context';
import './style.less';

class ChangeBtn extends React.Component {
  static propTypes = {
    prev: PropTypes.func,
    next: PropTypes.func,
    checkFunc: PropTypes.func,
    retryFunc: PropTypes.func,
    disabled: PropTypes.bool,
    retryBtn: PropTypes.bool,
  };

  handlePrev = () => {
    this.props.prev();
  }

  handleNext = () => {
    this.props.next();
  }

  handleCheck= () => {
    this.props.checkFunc();
  }

  handleRetry= () => {
    this.props.retryFunc();
  }

  render() {
    const { retryBtn, disabled } = this.props;
    return (
      <div className={`exercises-switch ${this.context}`}>
        <div className={`${this.context}-prev exercise-prev-btn`} onClick={this.handlePrev} />
        <div className="exercises-btn-wrapper">
          {!retryBtn && !disabled && <div className={`redo ${this.context}`} onClick={this.handleRetry}>Redo</div>}
          {!retryBtn && <div className={`check ${this.context} ${disabled ? 'disabled' : ''}`} onClick={!disabled ? this.handleCheck : null}>Check</div>}
          {retryBtn && <div className={`retry ${this.context}`} onClick={this.handleRetry}>retry</div>}
        </div>
        <div className={`${this.context}-next exercise-next-btn`} onClick={this.handleNext} />
      </div>
    );
  }
}

ChangeBtn.contextType = ThemeContext;

export default ChangeBtn;
